import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchCulpritPropertyInsuranceType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPropertyInsurance/patchCulpritPropertyInsurance.type';
import { patchCulpritPropertyInsuranceFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPropertyInsurance/patchCulpritPropertyInsuranceFunction';

export const PatchCulpritPropertyInsuranceOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchCulpritPropertyInsuranceType
> => ({
  mutationKey: ['patch-culprit-insurance-property'],
  mutationFn: ({ id, formData }: PatchCulpritPropertyInsuranceType) =>
    patchCulpritPropertyInsuranceFunction({ id, formData }),
});
